import React, { FC } from 'react';
import { ReactComponent as AppleLogoIcon } from '../../../../assets/images/apps/Apple.svg';
import './AppleIcon.scss';

interface AppleIconProps {
  className: string;
  size?: string;
}

const defaultProps = {
  size: 'default',
};

export const AppleIcon: FC<AppleIconProps> = ({ className, size }) => {
  const getIcon = (type: string) => {
    switch (type) {
      case 'big': {
        return (
          <div className={`apple-icon-container__big ${className}`}>
            <div className="apple-icon-container__big__container">
              <AppleLogoIcon className="apple-icon-container__big__container__icon" />
            </div>
          </div>
        );
      }
      default: {
        return (
          <div className={`apple-icon-container__small ${className}`}>
            <AppleLogoIcon className="apple-icon-container__small__icon" />
          </div>
        );
      }
    }
  };
  return getIcon(size || defaultProps.size);
};
AppleIcon.defaultProps = defaultProps;
